/**
 * Splits a formatted price into characters and marks which digits changed since the
 * previous price. Used by LivePriceTicker to roll only the digits that moved.
 * Pure function: keep it free of React so it can be tested on its own.
 */
export function diffPriceDigits(prevText, nextText) {
  const next = typeof nextText === "string" ? nextText : "";
  const prev = typeof prevText === "string" ? prevText : "";
  // A different length means the number gained or lost a digit (e.g. 9,999 → 10,000);
  // characters no longer line up, so treat it as a fresh value with nothing rolling.
  const comparable = prev.length === next.length && prev !== "";
  return next.split("").map((char, index) => ({
    char,
    changed: comparable && /\d/.test(char) && prev[index] !== char,
  }));
}

/** "up" when the price rose, "down" when it fell, null when unchanged or not comparable. */
export function priceDirection(prevValue, nextValue) {
  if (!Number.isFinite(prevValue) || !Number.isFinite(nextValue)) return null;
  if (nextValue > prevValue) return "up";
  if (nextValue < prevValue) return "down";
  return null;
}
